<template>
  <div>
    <p class="subtitle has-text-black">
      404 - Not Found
    </p>
    <div class="box">
      <div class="content">
        <b-button
          class="is-large is-fullwidth is-primary"
          @click="goBack"
        >
          Return
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'NotFound',

  data () {
    return {

    }
  },
  methods: {
    goBack() {
      if (window.history.length > 2) {
        this.$router.go(-2)
      } else {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
